/** Auto-curated port name → IANA timezone for Port Performance LT→UTC. */
export const PC_PORT_TIMEZONES: Record<string, string> = {
  "Algeciras": "Europe/Madrid",
  "Algier": "Africa/Algiers",
  "Aliaga": "Europe/Istanbul",
  "Aliaga ": "Europe/Istanbul",
  "Aoshan": "Asia/Shanghai",
  "Arica": "America/Santiago",
  "Aruba": "America/Aruba",
  "Aruba OPL": "America/Aruba",
  "Balboa": "America/Bogota",
  "Banjul": "Africa/Banjul",
  "Batam": "Asia/Jakarta",
  "Belawan": "Asia/Jakarta",
  "Benghazi": "Africa/Tripoli",
  "Benghazi Opl": "Africa/Tripoli",
  "Bilbao": "Europe/Madrid",
  "Bizerte": "Africa/Tunis",
  "Bosphorus": "Europe/Istanbul",
  "Bozcaada": "Europe/Istanbul",
  "Burgas": "Europe/Sofia",
  "Busan": "Asia/Seoul",
  "Canakkale": "Europe/Istanbul",
  "Ceuta": "Europe/Madrid",
  "Charleston": "America/New_York",
  "Chennai": "Asia/Kolkata",
  "Civitavecchia": "Europe/Rome",
  "Cochin": "Asia/Kolkata",
  "Colombo": "Asia/Colombo",
  "Constanta": "Europe/Bucharest",
  "Cotonou": "Africa/Porto-Novo",
  "Crete Island": "Europe/Athens",
  "Curacao": "America/Curacao",
  "Cyprus": "Asia/Nicosia",
  "Cyprus opl": "Asia/Nicosia",
  "DAKAR": "Africa/Dakar",
  "Dakar": "Africa/Dakar",
  "Dalian": "Asia/Shanghai",
  "Danish Strait": "Europe/Copenhagen",
  "Danish Straits": "Europe/Copenhagen",
  "Dardanelles": "Europe/Istanbul",
  "Dongjiakou": "Asia/Shanghai",
  "Dongying": "Asia/Shanghai",
  "Dortyol": "Europe/Istanbul",
  "Dumai - Lubuk Gaung": "Asia/Jakarta",
  "Duqm": "Asia/Muscat",
  "EL Dekheila": "Africa/Cairo",
  "El Dekheila": "Africa/Cairo",
  "Eopl Singapore": "Asia/Singapore",
  "Ereglisi": "Europe/Istanbul",
  "Falmouth": "Europe/London",
  "Flushing": "Europe/Amsterdam",
  "Fujairah": "Asia/Dubai",
  "Gaolan Zhuhai": "Asia/Shanghai",
  "Gdynia": "Europe/Warsaw",
  "Gebze": "Europe/Istanbul",
  "Gelibolu": "Europe/Istanbul",
  "Gibraltar": "Europe/Gibraltar",
  "Gibraltor Opl": "Europe/Gibraltar",
  "Great Belt": "Europe/Copenhagen",
  "Guamare": "America/Fortaleza",
  "Gulf of Kutch": "Asia/Kolkata",
  "Hambantota": "Asia/Colombo",
  "Hamriyah": "Asia/Dubai",
  "Hazira": "Asia/Kolkata",
  "Houston": "America/Chicago",
  "Huangdao": "Asia/Shanghai",
  "Huizhou": "Asia/Shanghai",
  "Iskenderun": "Europe/Istanbul",
  "Istanbul": "Europe/Istanbul",
  "Istanbul Drifting": "Europe/Istanbul",
  "Istanbul Strait": "Europe/Istanbul",
  "Istanbul strait": "Europe/Istanbul",
  "Istanbul Transit": "Europe/Istanbul",
  "Itacoatiara": "America/Manaus",
  "Itaqui": "America/Sao_Paulo",
  "Izmit": "Europe/Istanbul",
  "Jebel Ali": "Asia/Dubai",
  "Jeddah": "Asia/Riyadh",
  "Jeddah Opl": "Asia/Riyadh",
  "Kali Limenes": "Europe/Athens",
  "Kaliningard Opl": "Europe/Kaliningrad",
  "Karachi": "Asia/Karachi",
  "Karimun": "Asia/Jakarta",
  "Kavkaz": "Europe/Moscow",
  "Khasab": "Asia/Muscat",
  "Khorfakkan": "Asia/Dubai",
  "KM 171 (Parana River)": "America/Argentina/Buenos_Aires",
  "Kochi": "Asia/Kolkata",
  "Kozmino": "Asia/Vladivostok",
  "Kozmino OPL": "Asia/Vladivostok",
  "KUCUKCEKMECE": "Europe/Istanbul",
  "Kulevi": "Asia/Tbilisi",
  "La Coruna": "Europe/Madrid",
  "La Goulette": "Africa/Tunis",
  "La Skhirra": "Africa/Tunis",
  "LA_GOULETTE": "Africa/Tunis",
  "La_Skhirra": "Africa/Tunis",
  "Lesvos OPL": "Europe/Athens",
  "Lesvos Opl": "Europe/Athens",
  "Limassol": "Asia/Nicosia",
  "Lome": "Africa/Lome",
  "Maceio": "America/Maceio",
  "Mailiao": "Asia/Taipei",
  "Malta": "Europe/Malta",
  "Malta Opl": "Europe/Malta",
  "Manaus": "America/Manaus",
  "Marmara": "Europe/Istanbul",
  "Marmara Ereglisi": "Europe/Istanbul",
  "Marmara Sea": "Europe/Istanbul",
  "Mersin": "Europe/Istanbul",
  "mersin": "Europe/Istanbul",
  "Mersin Opl": "Europe/Istanbul",
  "Mindelo": "Atlantic/Cape_Verde",
  "Misrata": "Africa/Tripoli",
  "Mohammedia": "Africa/Casablanca",
  "Mumbai": "Asia/Kolkata",
  "Mumbai opl": "Asia/Kolkata",
  "Mundra": "Asia/Kolkata",
  "Murmansk": "Europe/Moscow",
  "murmansk": "Europe/Moscow",
  "New Mangalore": "Asia/Kolkata",
  "New Mangalore Anchorage": "Asia/Kolkata",
  "New Orleans": "America/Chicago",
  "new Orleans": "America/Chicago",
  "Ningbo": "Asia/Shanghai",
  "Nouadhibou": "Africa/Nouakchott",
  "NOVOROSSIYSK": "Europe/Moscow",
  "Novorossiysk": "Europe/Moscow",
  "novorossiysk": "Europe/Moscow",
  "Off Bozcaada Island": "Europe/Istanbul",
  "Opl Augusta": "Europe/Rome",
  "Opl Cyprus": "Asia/Nicosia",
  "OPL Falmouth": "Europe/London",
  "Opl Istanbul": "Europe/Istanbul",
  "Opl La Skhirra": "Africa/Tunis",
  "OPL Lesvos": "Europe/Athens",
  "Opl Lesvos": "Europe/Athens",
  "Opl Malta": "Europe/Malta",
  "Paranagua": "America/Sao_Paulo",
  "Pengerang": "Asia/Kuala_Lumpur",
  "Plymouth": "Europe/London",
  "Port Said": "Africa/Cairo",
  "Port said": "Africa/Cairo",
  "port said": "Africa/Cairo",
  "Port Said OPL": "Africa/Cairo",
  "Port Said Opl": "Africa/Cairo",
  "Port said OPL": "Africa/Cairo",
  "Port said Opl": "Africa/Cairo",
  "PORTO GRANDE": "America/Belem",
  "Primorsk": "Europe/Moscow",
  "Rabigh": "Asia/Riyadh",
  "Rio Grande": "America/Sao_Paulo",
  "Rizhao": "Asia/Shanghai",
  "rizhao": "Asia/Shanghai",
  "Samsun": "Europe/Istanbul",
  "Samsun OPL": "Europe/Istanbul",
  "Sandakan": "Asia/Kuching",
  "Santos": "America/Sao_Paulo",
  "Sikka": "Asia/Kolkata",
  "Singapore": "Asia/Singapore",
  "Singapore OPL": "Asia/Singapore",
  "Skagen": "Europe/Copenhagen",
  "Sohar": "Asia/Muscat",
  "SUEZ": "Africa/Cairo",
  "Suez": "Africa/Cairo",
  "Suez Canal": "Africa/Cairo",
  "Suez Opl": "Africa/Cairo",
  "TAICHUNG": "Asia/Taipei",
  "Tallinn": "Europe/Tallinn",
  "Tallinn Opl": "Europe/Tallinn",
  "Tangier": "Africa/Casablanca",
  "TEma": "Africa/Accra",
  "Tema": "Africa/Accra",
  "Thessaloniki": "Europe/Athens",
  "Tianjin": "Asia/Shanghai",
  "Tuapse": "Europe/Moscow",
  "Turkish Strait": "Europe/Istanbul",
  "Turkish Straits": "Europe/Istanbul",
  "Ust Luga": "Europe/Moscow",
  "Ventspils": "Europe/Riga",
  "Vila Do Conde": "Europe/Lisbon",
  "Visakhapatnam": "Asia/Kolkata",
  "Vysotsk": "Europe/Moscow",
  "Wilmington": "America/New_York",
  "Yalova": "Europe/Istanbul",
  "Yangpu": "Asia/Shanghai",
  "Zhoushan": "Asia/Shanghai",
  "Zhuhai": "Asia/Shanghai",
};

const PC_PORT_TIMEZONES_NORMALIZED: Record<string, string> = Object.fromEntries(
  Object.entries(PC_PORT_TIMEZONES).map(([port, tz]) => [
    port.trim().toLowerCase().replace(/\s+/g, ' '),
    tz,
  ]),
);

export function lookupPcPortTimeZone(
  port: string | null | undefined,
): string | null {
  if (!port) {
    return null;
  }
  const key = String(port).trim().toLowerCase().replace(/\s+/g, ' ');
  if (!key) {
    return null;
  }
  return PC_PORT_TIMEZONES_NORMALIZED[key] ?? null;
}
